import Image from 'next/image';
import Layout from '../../ui/layout';
import { Wrap } from '../../styled';
import {
  H3,
  IntroContainer,
  Intro,
  IntroText,
  Backdrop,
  Mission,
  MissionCell,
  MissionVideo,
  MissionText,
  About,
  AboutText,
  AboutImageMobile,
  AboutImageDesktop,
  HowItWorks,
  Text,
  LI,
  Technology,
  Story,
  HalfBlock,
} from './styled';

import teamMobile from './images/team-xs.png';
import teamDesktop from './images/team.png';

const OurStory = () => (
  <Layout>
    <IntroContainer>
      <Wrap>
        <Intro>
          <IntroText>
            Helping to create a sustainable apparel industry from manufacturing
            to the consumer&apos;s closet.
          </IntroText>
        </Intro>
      </Wrap>
    </IntroContainer>
    <Backdrop>
      <Wrap>
        <Mission>
          <MissionCell>
            <H3>Our Mission</H3>
            <MissionText>
              At EyeFitU, our mission is to revolutionize fashion e-commerce by
              providing intelligent, accurate size and fit recommendations that
              empower consumers and fashion brands. We are committed to making
              online shopping more personalized, efficient, and sustainable.
            </MissionText>
          </MissionCell>
          <MissionCell>
            <MissionVideo
              src="/images/our-story/body.mp4"
              autoPlay
              loop
              muted
              playsInline
            />
          </MissionCell>
        </Mission>
      </Wrap>
    </Backdrop>
    <Wrap>
      <About>
        <H3>What is EyeFitU?</H3>
        <AboutText>
          EyeFitU is a leading AI-driven Size & Fit Optimization Platform
          designed for fashion and footwear retailers. We help shoppers find
          their perfect fit across multiple brands and product types, reducing
          return rates and improving customer satisfaction. Impacting retailers’
          conversion rates, AOV and customer loyalty.
        </AboutText>
        <AboutImageMobile>
          <Image src={teamMobile} alt="" />
        </AboutImageMobile>
        <AboutImageDesktop>
          <Image src={teamDesktop} alt="" />
        </AboutImageDesktop>
      </About>
    </Wrap>
    <Backdrop>
      <Wrap>
        <HalfBlock>
          <H3>Our Impact</H3>
          <ul>
            <LI>
              <b>-35% to -55% average reduction in size-related returns</b>
            </LI>
            <LI>
              <b>+10% to +15% increase in customer conversion rates</b>
            </LI>
            <LI>
              <b>-10% to -15% in cart abandonment</b>
            </LI>
            <LI>
              Trusted by <b>500+ global retailers</b> in fashion and footwear
            </LI>
            <LI>
              Used in over <b>70 countries</b> by online shoppers
            </LI>
          </ul>
        </HalfBlock>
      </Wrap>
    </Backdrop>
    <Wrap>
      <HowItWorks>
        <H3>How It Works</H3>
        <Text>
          Our proprietary technology, <b>SizeEngine™ AI</b>, uses a combination
          of:
        </Text>
        <ul>
          <LI>Body measurement prediction</LI>
          <LI>Purchase behavior analysis</LI>
          <LI>Brand-specific fit calibration</LI>
          <LI>Product cut/style evaluation</LI>
        </ul>
        <Text>
          Together, these components deliver highly personalized and precise
          size recommendations—powered by real data and real insights.
        </Text>
      </HowItWorks>
    </Wrap>
    <Backdrop>
      <Wrap>
        <HalfBlock>
          <H3>Who We Help</H3>
          <ul>
            <LI>
              <b>Retailers:</b> Improve conversion rates, lower returns, and
              enhance the customer journey.
            </LI>
            <LI>
              <b>Shoppers:</b> Buy with confidence knowing the fit is right the
              first time.
            </LI>
            <LI>
              <b>The Planet:</b> Fewer returns = less waste = more sustainable
              shopping.
            </LI>
          </ul>
        </HalfBlock>
      </Wrap>
    </Backdrop>
    <Wrap>
      <Technology>
        <H3>Our Technology</H3>
        <ul>
          <LI>AI-based size prediction engine</LI>
          <LI>Cross-brand and cross-category recommendations</LI>
          <LI>Real-time adaptation to consumer feedback and trends</LI>
          <LI>Anthropometric and behavioural analytics</LI>
        </ul>
        <Text>
          We continuously train our models on live retail and return data,
          ensuring maximum accuracy and scalability for every client.
        </Text>
      </Technology>
    </Wrap>
    <Backdrop>
      <Wrap>
        <HalfBlock>
          <H3>Sustainability Commitment</H3>
          <Text>
            We are proud to be part of the movement for a greener fashion
            industry. By helping customers get it right the first time, we
            reduce:
          </Text>
          <ul>
            <LI>Carbon emissions from return shipments</LI>
            <LI>Waste from discarded or overproduced inventory</LI>
            <LI>Energy usage in reverse logistics</LI>
          </ul>
        </HalfBlock>
      </Wrap>
    </Backdrop>
    <Wrap>
      <Story>
        <H3>Our Story</H3>
        <Text>
          Founded by a team of fashion retail experts, data scientists, and
          technologists, EyeFitU emerged from a deep frustration with the poor
          sizing experience in online fashion. Since 2014, we’ve grown into a
          global partner for retailers who care about fit, conversion, and
          sustainability.
        </Text>
      </Story>
    </Wrap>
    <Backdrop>
      <Wrap>
        <HalfBlock>
          <H3>Join Us</H3>
          <Text>
            We work with brands who believe size and fit are essential to
            customer happiness. Let’s reshape the future of fashion shopping -
            together.
          </Text>
        </HalfBlock>
      </Wrap>
    </Backdrop>
  </Layout>
);

export default OurStory;
